import { useSmartBannerScroll } from '@/hooks/use-smartbanner-scroll';
import { getSmartBannerPadding, SMARTBANNER_TRANSITION } from '@/constants';
import type { SmartBannerConfig } from '@/constants';

interface LayoutWrapperProps {
  children: React.ReactNode;
  className?: string;
  role?: 'customer' | 'cleaner' | null; // Role for SmartBanner
}

export function LayoutWrapper({
  children,
  className,
  role,
}: LayoutWrapperProps) {
  const { smartbannerExited, isScrolled } = useSmartBannerScroll();

  const config: SmartBannerConfig = {
    role,
    isVisible: !smartbannerExited && !isScrolled,
    hasNavbar: true, // LayoutWrapper is used on pages with navbar
  };

  return (
    <main
      className={`
        w-full min-h-screen
        ${className || ''}
      `}
      style={{
        paddingTop: getSmartBannerPadding(config),
        transition: SMARTBANNER_TRANSITION,
      }}
    >
      {children}
    </main>
  );
}
